var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReconnectingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1111 1C14.7777 2.77778 16.9989 5.85945 16.9989 9.00105C16.9989 13.1183 13.8883 16.509 9.88882 16.9514M12.1111 1H16.1111M12.1111 1V5M8.10669 1.05109C4.1089 1.49501 1 4.88498 1 9.00105C1 12.1405 3.22217 15.2222 5.88885 17M5.88885 17H1.88885M5.88885 17V13",
    stroke: "#DC6803",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReconnectingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reconnectingIcon.fa914c29ed09e0d046ca5e56e6cbb291.svg";